import { Translation } from '../types';

export default  {
  // 애플리케이션
  appTitle: "OK Money - 라이프 플랜 시뮬레이터",
  
  // 내비게이션
  navigation: {
    home: "홈",
    lifePlan: "라이프 플랜",
    riskSimulation: "리스크 시뮬레이션",
    contact: "문의하기",
    openMenu: "메뉴 열기",
    lifePlanDescription: "미래 생활을 설계하는 라이프 플랜을 작성하세요",
    riskSimulationDescription: "투자 리스크를 평가하기 위한 리스크 시뮬레이션을 실행하세요",
  },

  // Home
  home: {
    hero: {
      title: "시뮬레이션을 통한 실제 생활 계획",
      subtitle: "불확실성을 고려한 시뮬레이션으로 인생 계획을 최적화하세요",
      download: "다운로드",
      docs: "문서"
    },
    features: {
      codeCompletion: {
        title: "실시간 시뮬레이션",
        description: "실시간으로 시장 변동을 시뮬레이션하고 최적의 자금 계획을 제안합니다"
      },
      codebase: {
        title: "AI 분석",
        description: "과거 데이터와 AI를 사용하여 투자 포트폴리오를 분석하고 개선점을 제안합니다"
      },
      naturalLanguage: {
        title: "삶을 풍요롭게 하는 투자",
        description: "일상 생활에 필요한 자금의 안전을 확보하면서 투자를 통해 자산을 증식하세요"
      }
    },
  },

  // 회사 정보 및 이용약관
  company: {
    title: "회사 정보",
    basicInfo: "기본 정보",
    operatorName: "운영 회사명",
    startDate: "설립일",
    startDateValue: "2025년 4월 28일",
    location: "소재지",
    locationValue: "가나가와현 요코하마시",
    contact: "문의하기",
    contactForm: "문의 양식",
    businessDescription: "사업 내용",
    businessDescriptionContent: "라이프 플랜 시뮬레이션 서비스 제공",
    developerProfile: "개발자 프로필",
    developerProfileContent: "SIer 엔지니어가 개인 개발하고 있습니다. 아이가 태어나 인생 설계를 하는 과정에서 미래와 현재를 마음껏 즐길 수 있도록 기여할 수 있는 서비스를 목표로 하고 있습니다.",
    privacyPolicy: "개인정보 처리방침",
    privacyPolicyLink: "개인정보 처리방침 전문 보기",
    termsOfService: "이용약관",
    termsOfServiceContent: "당사는 고객의 개인정보 보호를 최우선으로 생각하고 있습니다.",
    contentEnd: "궁금한 점이 있으시면 문의해 주세요."
  },
  terms: {
    title: "이용약관",
    termsOfService: "이용약관",
    privacyPolicy: "개인정보 처리방침",
    article1: {
      title: "제1조 (적용)",
      content: "본 약관은 OKMoney(이하 '당사')가 제공하는 서비스(이하 '본 서비스')의 이용 조건을 정하는 것입니다."
    },
    article2: {
      title: "제2조 (이용 등록)",
      content1: "1. 본 서비스를 이용하려면 본 약관에 동의한 후, 당사가 정한 방법으로 이용 등록을 해야 합니다.",
      content2: "2. 당사는 이용 등록 신청자에 대해 다음과 같은 사유가 있다고 판단할 경우, 이용 등록을 거부할 수 있습니다.",
      listItem1: "본 약관을 위반한 적이 있는 자로부터의 신청인 경우",
      listItem2: "기타 당사가 이용 등록이 적절하지 않다고 판단한 경우"
    },
    article3: {
      title: "제3조 (금지 사항)",
      content: "이용자는 다음 행위를 해서는 안 됩니다:",
      listItem1: "법령 또는 공서양속을 위반하는 행위",
      listItem2: "범죄 행위와 관련된 행위",
      listItem3: "당사의 서비스 운영을 방해할 우려가 있는 행위",
      listItem4: "다른 이용자에게 피해를 주는 행위",
      listItem5: "기타 당사가 부적절하다고 판단하는 행위"
    },
    article4: {
      title: "제4조 (본 서비스 제공의 중지 등)",
      content: "당사는 다음과 같은 사유가 있다고 판단할 경우, 이용자에게 사전 통지 없이 본 서비스의 전부 또는 일부 제공을 중지하거나 중단할 수 있습니다:",
      listItem1: "본 서비스에 관한 컴퓨터 시스템의 유지보수 또는 업데이트를 수행하는 경우",
      listItem2: "지진, 낙뢰, 화재, 정전 또는 천재지변 등으로 인해 본 서비스 제공이 어려운 경우",
      listItem3: "기타 당사가 본 서비스 제공이 어렵다고 판단한 경우"
    },
    article5: {
      title: "제5조 (면책 사항)",
      content: "당사는 본 서비스에 관해 이용자와 다른 이용자 또는 제3자 간에 발생한 거래, 연락 또는 분쟁 등에 대해 일체 책임을 지지 않습니다."
    },
    article6: {
      title: "제6조 (서비스 내용의 변경 등)",
      content: "당사는 이용자에게 통지 없이 본 서비스의 내용을 변경하거나 본 서비스의 제공을 중단할 수 있으며, 이로 인해 이용자에게 발생한 손해에 대해 일체의 책임을 지지 않습니다."
    },
    article7: {
      title: "제7조 (이용약관의 변경)",
      content: "당사는 필요하다고 판단할 경우, 이용자에게 통지 없이 언제든지 본 약관을 변경할 수 있습니다."
    },
    article8: {
      title: "제8조 (통지 또는 연락)",
      content: "이용자와 당사 간의 통지 또는 연락은 당사가 정한 방법으로 합니다."
    },
    article9: {
      title: "제9조 (권리 의무의 양도 금지)",
      content: "이용자는 당사의 서면에 의한 사전 동의 없이 이용 계약상의 지위 또는 본 약관에 따른 권리나 의무를 제3자에게 양도하거나 담보로 제공할 수 없습니다."
    },
    article10: {
      title: "제10조 (준거법·재판 관할)",
      content1: "1. 본 약관의 해석에 있어서는 일본법을 준거법으로 합니다.",
      content2: "2. 본 서비스에 관해 분쟁이 발생한 경우에는 당사의 본점 소재지를 관할하는 법원을 전속적 합의 관할로 합니다."
    },
    privacy: {
      article1: {
        title: "1. 개인정보 수집에 관하여",
        content: "본 사이트에서는 서비스 제공을 위해 다음과 같은 개인정보를 수집할 수 있습니다:",
        listItem1: "성명",
        listItem2: "이메일 주소",
        listItem3: "주소",
        listItem4: "전화번호",
        listItem5: "기타 서비스 제공에 필요한 정보"
      },
      article2: {
        title: "2. 개인정보의 이용 목적",
        content: "수집한 개인정보는 다음과 같은 목적으로 이용됩니다:",
        listItem1: "서비스 제공 및 운영",
        listItem2: "문의에 대한 대응",
        listItem3: "서비스 개선 및 개발",
        listItem4: "중요한 안내 사항의 통지"
      },
      article3: {
        title: "3. 개인정보의 관리",
        content: "본 사이트에서는 개인정보의 유출, 손실, 훼손을 방지하기 위해 적절한 보안 대책을 실시하고 있습니다."
      },
      article4: {
        title: "4. 개인정보의 제3자 제공",
        content: "본 사이트에서는 다음의 경우를 제외하고 개인정보를 제3자에게 제공하지 않습니다:",
        listItem1: "본인의 동의가 있는 경우",
        listItem2: "법령에 근거하는 경우",
        listItem3: "사람의 생명, 신체 또는 재산의 보호를 위해 필요한 경우"
      },
      article5: {
        title: "5. 문의",
        content: "개인정보 처리방침에 관한 문의는 문의 양식을 통해 연락해 주세요."
      },
      article6: {
        title: "6. 개인정보 처리방침의 변경",
        content: "본 사이트는 필요에 따라 본 개인정보 처리방침을 변경할 수 있습니다. 변경 시에는 본 사이트에서 안내합니다."
      }
    }
  },

  // 공통
  common: {
    years: "년",
    perYear: "/년",
    perMonth: "/월",
    age: "나이",
    yes: "예",
    no: "아니오",
    none: "없음",
    notEntered: "미입력",
    add: "추가",
    delete: "삭제",
    save: "저장",
    cancel: "취소",
    reset: "초기화",
    month: "월",
    select: "선택",
    clearSelection: "선택 해제",
    dateTime: "날짜 및 시간",
    actions: "작업",
    currencies: {
      jpy: "일본 엔화",
      usd: "미국 달러",
      eur: "유로",
      gbp: "영국 파운드",
      aud: "호주 달러",
      cad: "캐나다 달러",
      chf: "스위스 프랑",
      cny: "중국 위안",
      hkd: "홍콩 달러",
      sgd: "싱가포르 달러"
    },
    currency: "통화",
    currencyHelp: "통화를 선택하세요. 시뮬레이션은 선택한 통화로 진행됩니다.",
    statistics: {
      title: "통계",
      mean: "평균",
      median: "중앙값",
      min: "최소값",
      max: "최대값",
      mode: "최빈값",
      totalInvestment: "총 투자액",
      assetDistribution: "자산 배분",
      targetAchieveRate: "목표 달성률",
      probability: "확률",
      medianFinalAsset: "중앙값 최종 자산",
      finalAsset: "최종 자산",
    }
  },

  // 리스크 시뮬레이션
  riskSimulation: {
    title: "리스크 시뮬레이션",
    simulationSettings: "시뮬레이션 설정",
    initialInvestment: "초기 투자액",
    investmentAmount: "투자액",
    investmentPeriod: "투자 기간",
    annualReturnRate: "연간 수익률",
    monthlyInvestment: "월간 투자액",
    volatility: "변동성",
    targetAmount: "목표 금액",
    runSimulation: "시뮬레이션 실행",
    running: "실행 중",
    simulationInstruction: "먼저 시뮬레이션을 실행해 주세요.",
    noSimulationRun: "시뮬레이션 미실행",
    simulationResults: "시뮬레이션 결과",
    currentResults: "현재 결과",
    savedResults: "저장된 결과",
    compare: "비교",
    resultTitle: "리스크 시뮬레이션 결과",
    simulationConditions: "시뮬레이션 조건",
    saveSimulationResult: "시뮬레이션 결과 저장",
    saveSimulationDescription: "시뮬레이션 결과의 이름을 입력해 주세요.",
    simulationName: "시뮬레이션 이름",
    simulationNamePlaceholder: "시뮬레이션 결과의 이름을 입력",
    saveSimulation: "시뮬레이션 저장",
    noSavedSimulations: "저장된 시뮬레이션 없음",
    noSavedSimulationsDescription: "저장된 시뮬레이션이 없습니다. 먼저 시뮬레이션을 실행해 주세요.",
    createNewSimulation: "새 시뮬레이션 생성",
    selectSimulationsToCompare: "비교할 시뮬레이션 선택",
    noSelectedSimulations: "선택된 시뮬레이션 없음",
    selectTwoOrMoreSimulations: "2개 이상의 시뮬레이션을 선택해 주세요.",
    comparisonResults: "비교 결과",
    finalAssetComparison: "최종 자산 비교",
    finalAssetComparisonDescription: "시뮬레이션의 최종 자산 비교",
    successRateComparison: "성공률 비교",
    successRateComparisonDescription: "시뮬레이션의 성공률 비교",
    simulationParameters: "시뮬레이션 매개변수",
    simulationParametersDescription: "시뮬레이션의 매개변수 비교",
    period: "기간",
    successRate: "성공률",
    backToSimulation: "시뮬레이션으로 돌아가기",
  },

  // 라이프 플랜
  lifePlan: {
    title: "라이프 플랜 작성",
    resultTitle: "라이프 플랜 시뮬레이션 결과",
    steps: {
      basicInfo: "기본 정보",
      incomeExpense: "수입·지출",
      assetsLiabilities: "자산·부채",
      lifeGoals: "라이프 이벤트",
      simulationSettings: "시뮬레이션 설정",
      confirmation: "확인",
    },
    navigation: {
      prev: "이전",
      next: "다음",
      startSimulation: "시뮬레이션 시작",
      confirmStart: "시뮬레이션을 시작하시겠습니까?",
      confirmStartTitle: "시뮬레이션 시작 확인",
      cancel: "취소",
    },
    basicInfo: {
      title: "기본 정보",
      name: "이름",
      namePlaceholder: "이름을 입력",
      age: "나이",
      gender: {
        title: "성별",
        male: "남성",
        female: "여성",
        other: "기타",
      },
      familyStructure: {
        title: "가족 구성",
        hasSpouse: "배우자 있음",
        spouseAge: "배우자 나이",
        children: "자녀",
        help: "가족 구성을 입력",
        childrenHelp: "자녀의 나이를 입력",
        addChild: "자녀 추가",
        removeChild: "자녀 삭제",
        noChildren: "자녀 없음",
      },
      spouse: "배우자",
      children: "자녀"
    },
    incomeExpense: {
      title: "수입·지출",
      income: {
        title: "수입",
        annualIncome: "연간 수입",
        salaryIncreaseRate: "급여 인상률",
        annualBonus: "연간 보너스",
      },
      expense: {
        title: "지출",
        help: "월간 지출을 입력해 주세요",
        housingCost: "주거비",
        housingCostHelp: "월세나 대출 상환액을 입력해 주세요",
        utilities: "공과금",
        food: "식비",
        communication: "통신비",
        transportation: "교통비",
        entertainment: "여가비",
        investment: "투자",
        stocks: "주식 투자",
        bonds: "채권 투자",
        mutualFunds: "투자 신탁",
        insurance: "보험료",
        other: "기타"
      },
      annualIncome: "연간 수입",
      salaryIncreaseRate: "급여 인상률",
      annualBonus: "연간 보너스",
      housingCost: "주거비",
      utilities: "공과금",
      food: "식비",
      communication: "통신비",
      transportation: "교통비",
      entertainment: "여가비",
      other: "기타"
    },
    assetsLiabilities: {
      title: "자산·부채",
      assets: {
        title: "자산",
        savings: "예금",
        stocks: "주식",
        bonds: "채권",
        mutualFunds: "투자 신탁",
        insurance: "보험",
        other: "기타",
        amount: "금액",
        return: "기대 수익률",
        volatility: "변동성",
        investmentAssets: "투자 자산",
      },
      liabilities: {
        title: "부채",
        housingLoan: "주택대출",
        carLoan: "자동차대출",
        otherLoans: "기타대출",
        addLoan: "대출추가",
        removeLoan: "대출삭제",
        name: "대출명",
        amount: "대출금액",
        period: "상환기간(년)",
        interestRate: "이자율(%)",
        noLoans: "대출없음",
      },
      savings: "예금",
      stocks: "주식",
      bonds: "채권",
      mutualFunds: "투자 신탁",
      insurance: "보험",
      otherInvestments: "기타 투자",
      housingLoanBalance: "주택대출 잔액",
      housingLoanPeriod: "대출 기간",
      housingLoanInterest: "이자율",
      noLoans: "대출없음",
      otherLoans: "기타 대출"
    },
    lifeGoals: {
      title: "라이프 이벤트",
      housingPurchase: "주택 구매",
      educationFunds: "교육 자금",
      child: "자녀",
      otherGoals: "기타 목표",
      retirementAge: "퇴직 연령",
      retirementMonthlyExpense: "퇴직 후 월간 지출",
      notPlanned: "미계획",
      housing: {
        title: "주택 구매",
        planned: "주택 구매 예정",
        year: "구매 예정 연도",
        amount: "구매 예정 금액",
        purchaseYear: "구매 연도",
        purchaseAmount: "구매 금액",
      },
      education: {
        title: "교육 자금 계획",
        subtitle: "교육 자금 계획",
        add: "교육 자금 추가",
        remove: "교육 자금 삭제",
        name: "교육 자금 이름",
        namePlaceholder: "교육 자금 이름 입력",
        childAge: "자녀 나이",
        age: "필요 나이",
        amount: "필요 금액",
        requiredAmount: "필요 금액",
        noData: "교육 자금이 추가되지 않음",
      },
      other: {
        title: "기타 목표",
        subtitle: "기타 인생 이벤트",
        add: "목표 추가",
        remove: "목표 삭제",
        name: "목표명",
        year: "목표 연도",
        amount: "필요 금액 (백만 엔)",
        noData: "목표 없음",
        namePlaceholder: "다른 목표 이름을 입력하세요",
        plannedAge: "계획 연령",
        requiredAmount: "필요 금액"
      },
      retirement: {
        title: "퇴직 계획",
        age: "예정 퇴직 연령",
        monthlyExpense: "퇴직 후 월간 지출",
      },
    },
    simulationSettings: {
      title: "시뮬레이션 설정",
      inflationRate: "인플레이션율",
      investmentReturn: "투자 수익률",
      simulationPeriod: "시뮬레이션 기간",
      currency: "통화",
      currencyHelp: "통화를 선택하세요. 시뮬레이션은 선택한 통화로 진행됩니다.",
      inflationRateHelp: "향후 물가 상승률을 고려한 시뮬레이션을 수행합니다."
    },
    runningSimulation: "시뮬레이션 실행 중",
    result: {
      title: "라이프 플랜 시뮬레이션 결과",
      settings: "라이프 플랜 설정",
      planSettings: "플랜 설정",
      actions: {
        print: "인쇄",
        downloadCSV: "CSV 다운로드",
        modifyConditions: "조건 수정",
        backToInput: "입력 화면으로 돌아가기",
      },
      tabs: {
        charts: "차트",
        details: "상세",
        analysis: "분석 및 추천",
      },
      charts: {
        assetIncomeExpense: "자산 및 수입/지출 추이",
        agePoint: "{age}세 시점",
        spouse: "배우자: {age}세",
        children: "자녀",
        age: "{age}세",
        assets: "자산",
        liabilities: "부채",
        netWorth: "순자산",
        amount: "금액",
        noData: "데이터가 없습니다",
        assetTrend: "자산 추이",
        incomeExpenseTrend: "수입/지출 추이",
        income: "수입",
        expense: "지출",
        savings: "저축",
      },
      details: {
        yearlyData: "연간 데이터 상세",
      },
      analysis: {
        risk: "리스크 분석",
        recommendations: "개선 추천 사항",
      },
      table: {
        search: "검색...",
        age: "나이",
        familyAge: "가족 나이",
        income: "수입",
        expense: "지출",
        savings: "저축",
        assets: "자산 잔액",
        lifeEvents: "라이프 이벤트",
        ageValue: "{age}세",
        spouse: "배우자: {age}세",
        children: "자녀",
        amount: "만원",
        noData: "데이터가 없습니다",
      },
      timeline: {
        age: "나이",
        event: "이벤트",
        retirement: "퇴직",
        ageValue: "{age}세",
        agePoint: "{age}세 시점",
        spouse: "배우자: {age}세",
        children: "자녀",
        neededAmount: "필요 금액: {amount}",
        assets: "자산: {amount}",
        education: "{childName}의 {fundName}",
        child: "자녀",
        educationFund: "교육 자금"
      },
      summary: {
        title: "요약",
        monthlyIncome: "월간 수입",
        monthlyExpense: "월간 지출",
        monthlyInvestment: "월간 투자액",
        monthlySavings: "월간 저축액",
        totalAssets: "총 자산",
        totalLiabilities: "총 부채",
        netWorth: "순자산",
        finalAssets: "최종 자산",
        peakAssets: "피크 시점 자산",
        retirementAssets: "퇴직 시점 자산",
        savingsRate: "저축률",
        savingsRateDesc: "수입 대비 저축 비율",
        retirementBalance: "퇴직 후 수지",
        balance: "수지",
        riskAssessment: "리스크 평가",
        riskLow: "저리스크",
        riskMedium: "중리스크",
        riskHigh: "고리스크",
        negativeAssets: "향후 자산이 마이너스가 되는 기간이 있습니다.",
        positiveAssets: "자산은 항상 플러스를 유지할 것으로 예상됩니다.",
        needImprovement: "수입·지출의 개선이 필요합니다.",
        unit: "만원",
        atAge: "{age}세 시점",
      },
      chart: {
        title: "자산 추이 미리보기",
        noData: "데이터를 입력해 주세요",
        assets: "자산",
        income: "수입",
        expense: "지출",
      },
    },
    confirmation: {
      title: "확인"
    },
    validation: {
      error: "입력 내용에 오류가 있습니다."
    },
  },
  login: "로그인",
  register: "회원가입",
  loginDescription: "계정이 없으신가요? 회원가입해 주세요.",
  registerDescription: "라이프 플랜 시뮬레이션을 시작하려면 계정을 만드세요.",
  email: "이메일",
  password: "비밀번호",
  passwordRequirements: "비밀번호는 8자 이상이며, 영문자와 숫자를 포함해야 합니다.",
  loggingIn: "로그인 중...",
  registering: "회원가입 중...",
  loginFailed: "로그인에 실패했습니다.",
  registrationSuccess: "회원가입이 완료되었습니다.",
  registrationFailed: "회원가입에 실패했습니다.",
  myPage: "마이페이지",
  logout: "로그아웃",
  userProfile: "사용자 프로필",
  userProfileDescription: "프로필 정보 관리",
  savedSimulations: "저장된 시뮬레이션",
  savedSimulationsDescription: "저장된 시뮬레이션 결과 목록",
  settings: "설정",
  accountSettings: "계정 설정",
  accountSettingsDescription: "계정 설정 관리",
  changePassword: "비밀번호 변경",
  changePasswordDescription: "비밀번호를 변경합니다",
} as Translation; 